/* assets/winschoon-3d-menu.js - 3D kanteleffect en meebewegend licht voor het Winschoon-menu. Puur visueel. */
(function () {
  'use strict';
  var header = document.querySelector('[data-header]');
  if (!header || !window.matchMedia) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || calm) return;

  header.addEventListener('pointermove', function (e) {
    var rect = header.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    header.style.setProperty('--w3d-mx', Math.max(0, Math.min(100, x)).toFixed(1) + '%');
  });

  Array.prototype.forEach.call(header.querySelectorAll('.site-header__nav-link'), function (link) {
    link.addEventListener('pointermove', function (e) {
      var r = link.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      link.style.setProperty('--w3d-ry', (px * 14).toFixed(1) + 'deg');
      link.style.setProperty('--w3d-rx', (-py * 10).toFixed(1) + 'deg');
    });
    link.addEventListener('pointerleave', function () {
      link.style.removeProperty('--w3d-ry');
      link.style.removeProperty('--w3d-rx');
    });
  });
})();
